import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { AuthService, User } from './services/auth';
import { FeatureFlagService } from './services/feature-flag';
import { filter } from 'rxjs/operators';

// Note: Routing is now provided in main.ts using provideRouter

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit, AfterViewInit {
  currentUser: User | null = null;
  /** True when the current route is a public share page (/share/:token) */
  isShareRoute = false;

  constructor(
    public authService: AuthService,
    private router: Router,
    public featureFlags: FeatureFlagService
  ) {}

  ngOnInit() {
    // Track whether we're on a public share route (hide app chrome)
    this.isShareRoute = this.router.url.startsWith('/share/');
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    ).subscribe(e => {
      this.isShareRoute = e.urlAfterRedirects.startsWith('/share/');
    });

    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;

      const path = window.location.pathname;
      if (!user && (path === '/' || this.router.url === '/') && !path.startsWith('/share/') && !path.startsWith('/login') && !path.startsWith('/register')) {
        this.router.navigate(['/login']);
      } else if (user && this.router.url === '/login') {
        this.router.navigate(['/dashboard']);
      }
    });
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  toggleDevUserView() {
    this.featureFlags.toggleUserView();
  }

  ngAfterViewInit() {
    // Set initial theme based on system preference
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (prefersDark) {
      document.body.classList.add('dark-theme');
    }
  }

  // Method to handle theme toggle - called from template
  toggleTheme() {
    const isDark = document.body.classList.toggle('dark-theme');
    const themeIcon = document.getElementById('theme-toggle-icon');
    if (themeIcon) {
      themeIcon.textContent = isDark ? '☀️' : '🌙';
    }
  }
}
